var _style;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      cursor: "pointer"
    },
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".filter-cls-1{fill:url(#filter-linear-gradient);}.filter-cls-2{fill:#e31f26;}.filter-cls-3{fill:#fffcd5;}.filter-cls-4{fill:url(#filter-linear-gradient-2);}.filter-cls-5{fill:url(#filter-linear-gradient-3);}.filter-cls-6{fill:url(#filter-linear-gradient-4);}")), /*#__PURE__*/React.createElement("linearGradient", {
    style: {
      cursor: "pointer"
    },
    id: "filter-linear-gradient",
    x1: 99.36,
    y1: 184.15,
    x2: 99.36,
    y2: 14.61,
    gradientTransform: "translate(99.38 -41.15) rotate(45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      cursor: "pointer"
    },
    offset: 0.31,
    stopColor: "#f5da52"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      cursor: "pointer"
    },
    offset: 1,
    stopColor: "#fff799"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    style: {
      cursor: "pointer"
    },
    id: "filter-linear-gradient-2",
    x1: 99.36,
    y1: 3.71,
    x2: 99.36,
    y2: 77.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      cursor: "pointer"
    },
    offset: 0.24,
    stopColor: "#fff450"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      cursor: "pointer"
    },
    offset: 0.57,
    stopColor: "#fff450"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      cursor: "pointer"
    },
    offset: 0.62,
    stopColor: "#fff450"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      cursor: "pointer"
    },
    offset: 0.73,
    stopColor: "#fff250"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      cursor: "pointer"
    },
    offset: 0.78,
    stopColor: "#feea4e"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      cursor: "pointer"
    },
    offset: 0.83,
    stopColor: "#fcdc4b"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      cursor: "pointer"
    },
    offset: 0.86,
    stopColor: "#f9c948"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      cursor: "pointer"
    },
    offset: 0.9,
    stopColor: "#f6b043"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      cursor: "pointer"
    },
    offset: 0.93,
    stopColor: "#f2923d"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      cursor: "pointer"
    },
    offset: 0.95,
    stopColor: "#ed6d35"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      cursor: "pointer"
    },
    offset: 0.98,
    stopColor: "#e8442d"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      cursor: "pointer"
    },
    offset: 1,
    stopColor: "#e31f26"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    style: {
      cursor: "pointer"
    },
    id: "filter-linear-gradient-3",
    x1: 99.75,
    y1: 35.75,
    x2: 99.75,
    y2: 109.63,
    xlinkHref: "#filter-linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    style: {
      cursor: "pointer"
    },
    id: "filter-linear-gradient-4",
    x1: 99.36,
    y1: 67.79,
    x2: 99.36,
    y2: 141.67,
    xlinkHref: "#filter-linear-gradient-2"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      cursor: "pointer"
    },
    className: "filter-cls-1",
    cx: 99.36,
    cy: 99.38,
    r: 84.77,
    transform: "translate(-41.17 99.37) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      cursor: "pointer"
    },
    className: "filter-cls-2",
    d: "M99.36,14.61A84.77,84.77,0,1,1,14.59,99.38,84.77,84.77,0,0,1,99.36,14.61m0-5.23a90,90,0,0,0-35,172.93A90,90,0,0,0,134.4,16.46a89.37,89.37,0,0,0-35-7.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      cursor: "pointer"
    },
    className: "filter-cls-3",
    d: "M99.36,20.39a84.76,84.76,0,0,1,84.7,81.88c0-1,.08-1.92.08-2.89a84.78,84.78,0,0,0-169.55,0c0,1,0,1.93.07,2.89A84.77,84.77,0,0,1,99.36,20.39Z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      cursor: "pointer"
    },
    className: "filter-cls-3",
    cx: 99.36,
    cy: 99.38,
    r: 69.87
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      cursor: "pointer"
    },
    className: "filter-cls-4",
    x: 49.36,
    y: 60.92,
    width: 100.01,
    height: 16.67,
    rx: 7.78
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      cursor: "pointer"
    },
    className: "filter-cls-5",
    x: 66.41,
    y: 92.96,
    width: 66.67,
    height: 16.67,
    rx: 7.78
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      cursor: "pointer"
    },
    className: "filter-cls-6",
    x: 77.14,
    y: 125,
    width: 44.45,
    height: 16.67,
    rx: 7.78
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.2985e24c.svg";
export { ForwardRef as ReactComponent };